import { useMemo } from 'react';
import pluralize from 'pluralize';
import ModelValueRow from 'src/features/messages/meta-panel/ModelValueRow';
import { useModels } from 'src/features/models/queries/useModels';
import { MessageType } from 'src/features/messages/types/message.types';
import SubtleCapsHeaders from 'src/shared/components/typography/SubtleCapsHeaders';
import { Model } from 'src/shared/types/model.types';

type ModelPanelProps = {
  message: MessageType;
};

export function getModelsForInbox(models: Model[], inboxId: string) {
  return models?.filter(
    (model) => !model.isNer && model.active && (model.inboxes.all || model.inboxes.ids.includes(inboxId))
  );
}

export default function ModelPanel({ message }: ModelPanelProps) {
  const { data: models } = useModels();

  const activeModelsForInbox = useMemo(() => {
    return models
      ?.filter(
        (model) =>
          !model.isNer && model.active && (model.inboxes.all || model.inboxes.ids.includes(message.integration_id))
      )
      .filter((model) => !message.models[model.id]);
  }, [models, message.integration_id, message.models]);

  const messageModels = Object.entries(message.models).filter(([_, value]) => value);
  const hasModels = messageModels.length > 0;

  return (
    <div className="flex flex-col gap-4 text-sm p-2">
      {hasModels && (
        <div className="flex flex-col gap-2">
          {messageModels.map(([modelId, data]) => {
            return (
              <ModelValueRow
                key={modelId}
                integrationId={message.integration_id}
                threadId={message.thread_id}
                modelId={modelId}
                values={data}
                isVerified={message.facets_versions?.[modelId] === 'actual'}
              />
            );
          })}
        </div>
      )}
      <div>
        {activeModelsForInbox && activeModelsForInbox.length > 0 && (
          <div className="pt-2">
            <SubtleCapsHeaders>
              {activeModelsForInbox.length} empty {pluralize('model', activeModelsForInbox.length)}
            </SubtleCapsHeaders>

            <div className="flex flex-col gap-2 mt-1">
              {activeModelsForInbox.map((model) => (
                <ModelValueRow
                  key={model.id}
                  integrationId={message.integration_id}
                  threadId={message.thread_id}
                  modelId={model.id}
                  isVerified={false}
                />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
